<template>
  <div class="input-wrapper">
    <div class="input-area">
      <el-input 
        @change="handleChange" 
        v-model="localValue" 
        placeholder="请输入" 
        clearable 
        style="width: 200px;" 
      />
    </div>
    <div class="info-area">
      <div class="title">普通输入框(自定义样式)</div>
      <div class="current-value" v-if="localValue">
        <span class="label">绑定值:</span>
        <span class="value">{{ localValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomInput',
  data() {
    return {
      localValue: ''
    }
  },
  methods: {
    handleChange() {
      console.log(this.localValue);
    }
  }
}
</script>

<style scoped lang="scss">
.input-wrapper {
  text-align: center;
}
.input-area {
  margin-bottom: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-area {
  text-align: left;
  padding-top: 15px;
}
.title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}
.current-value {
  font-size: 12px;
  color: #606266;
  background: var(--surface-2);
  padding: 8px;
  border-radius: 3px;
  word-break: break-all;
  line-height: 1.4;
}
.current-value .label {
  font-weight: bold;
  color: #409EFF;
  margin-right: 5px;
}

/* el样式 */
::v-deep .el-input__inner::placeholder {
  color: #fff;
}
::v-deep .el-input__inner{
  background-color: rgba(8, 35, 62, 0.9) !important;
  border: 1px solid rgb(83, 185, 232) !important;
  color: #fff !important;
  height: 32px;
  line-height: 32px;
}
::v-deep .el-input__suffix {
  right: -30px !important;
}
</style>
